export enum OrderTypesEnum {
  OrderTypes = "OrderTypes",
  PO = 1,
  EX = 2,
  RO = 3,
}
export default OrderTypesEnum;
